import {SET_PLANS} from '../actions/types';


const plans = (state = null, action) => {
  switch (action.type) {
    case SET_PLANS:
      return action.payload;
    default:
      return state;
  }
};

export default plans;